import React from 'react';
import {Provider} from 'react-redux'
import {store} from "../store";
import {CacheProvider} from "@emotion/react";
import {Favorites} from "./favorites";
import {ChakraProvider} from "@chakra-ui/react";
import {theme} from "../theme";
import createCache from "@emotion/cache";
import {createRoot} from "react-dom/client";

class FavoritesWebComponent extends HTMLElement {
    constructor() {
        super();

        const shadowRoot = this.attachShadow({mode: "open"});
        const root = document.createElement("duv");
        shadowRoot.appendChild(root);

        const cache = createCache({
            container: shadowRoot,
            key: "c"
        })

        const reactDom = createRoot(root);

        reactDom.render(
            <Provider store={store}>
                <CacheProvider value={cache}>
                    <ChakraProvider theme={theme}>
                        <Favorites/>
                    </ChakraProvider>
                </CacheProvider>
            </Provider>
        )
    }
}

if(!customElements.get('file-favorites')) {
    customElements.define('file-favorites', FavoritesWebComponent);
}
